/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React from 'react';
import noop from 'lodash/noop';

import { Block, ErrorMessage } from '@atoms';
import { SlugField, TextField, LocaleSelect, InfoItem, SortableArrayField, BookField } from '@molecules';
import RichTextField from '@molecules/RichTextField';
import { NO_MARGIN_BOTTOM } from '@constants';
import ROUTES from '@constants/routes';

import Form from '../Form';

import { FORM_FIELD, FORM_FIELDS, DEFAULT_VALUES } from './constants';

const ChapterForm = ({ initialValues = {}, error, form, chapterId, locale, onSaveDraft, onPublish }) => {
  const initialParentBook = initialValues[FORM_FIELD.PARENT_BOOK.name];
  return (
    <Form form={form} hideRequiredMark layout="vertical" wrapperCol={{ span: 24 }} initialValues={initialValues}>
      <ErrorMessage error={error} variant="block" spaced />
      <Block spaced>
        <BookField {...FORM_FIELD.PARENT_BOOK} initialParentBook={initialParentBook} style={NO_MARGIN_BOTTOM} />
      </Block>
      <Block spaced>
        <LocaleSelect
          locale={locale}
          disabled={!chapterId}
          route={`${ROUTES.CHAPTERS}/:id/:locale`}
          needsSave={form.isFieldsTouched}
          onSaveDraft={onSaveDraft}
          onPublish={onPublish}
        />
        <TextField {...FORM_FIELD.TITLE} />
        <SlugField
          {...FORM_FIELD.SLUG}
          generateSlugFrom={!initialValues[FORM_FIELD.SLUG.name] && FORM_FIELD.TITLE.name}
        />
        <RichTextField {...FORM_FIELD.TEXT} />
        <TextField multiline {...FORM_FIELD.SEO_DESCRIPTION} style={NO_MARGIN_BOTTOM} />
      </Block>
      {/* Stupid hack to make antd form properly update form */}
      <Form.List noStyle name={FORM_FIELD.SECTIONS.name}>
        {noop}
      </Form.List>
      {form.getFieldValue(FORM_FIELD.SECTIONS.name)?.length > 0 && (
        <Block>
          <SortableArrayField {...FORM_FIELD.SECTIONS}>
            {(section) => (
              <InfoItem>
                <a href={`${ROUTES.SECTIONS}/${section.id}`} rel="noopener noreferrer" style={{ color: '#b3b3b3' }}>
                  {section.title}
                </a>
              </InfoItem>
            )}
          </SortableArrayField>
        </Block>
      )}
    </Form>
  );
};

ChapterForm.useForm = () => Form.useForm(FORM_FIELDS, DEFAULT_VALUES);

export default ChapterForm;
